import AddCommentModal from './AddCommentModal'
import { Loading } from '../../../../shared/loading'
import { useGroupByIdQuery } from '../../../../../generated/graphql'
import useModal from '../../../../../lib/hooks/useModal'
import useNotification from '../../../../../lib/hooks/useNotification'

type AddCommentModalWrapperProps = {
  /** Current Plan Group ID */
  groupId: string
  /** Indicates if the modal is open */
  isOpen: boolean
  /** Indicates if this plan is a template */
  isTemplate: boolean
  /** Indicates if this plan/template is read-only */
  readOnly?: boolean | undefined
  /** Show the add comment field when clicking Add Comment from the group menu */
  showAddComment: boolean
  /** Show the comments when clicking on the comment count button */
  showComments: boolean
  /** Show the new comment indicator for this term/group */
  showNewCommentIndicator: boolean
}

const AddCommentModalWrapper = ({
  groupId,
  isOpen,
  isTemplate,
  readOnly = false,
  showAddComment,
  showComments,
  showNewCommentIndicator
}: AddCommentModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showErrorNotif } = useNotification()
  const groupQuery = useGroupByIdQuery({
    variables: { id: groupId.toString() },
    onError: () => {
      showErrorNotif('An error occurred. Please refresh the page.')
    }
  })

  if (groupQuery.loading) {
    return <Loading />
  }

  const onCancel = () => {
    hideModal()
  }

  const onSave = () => {
    if (groupQuery.data!.planGroup.comments.length === 1) {
      hideModal()
    }
  }

  return (
    <AddCommentModal
      group={groupQuery.data!.planGroup}
      isOpen={isOpen}
      isTemplate={isTemplate}
      onCancel={onCancel}
      onSave={onSave}
      readOnly={readOnly}
      showAddComment={showAddComment}
      showComments={showComments}
      showNewCommentIndicator={showNewCommentIndicator}
    />
  )
}

export default AddCommentModalWrapper
